export default "__VITE_ASSET__0Mrtcx2g__"